const ADMIN_MFA_SESSION_KEY = 'ADMIN_MFA_SESSION_SATISFIED';

function storageKey(username) {
  return username ? `${ADMIN_MFA_SESSION_KEY}:${username}` : ADMIN_MFA_SESSION_KEY;
}

export function markAdminMfaSessionSatisfied(username) {
  if (!username) {
    return;
  }

  sessionStorage.setItem(storageKey(username), '1');
}

export function clearAdminMfaSessionSatisfied(username) {
  if (username) {
    sessionStorage.removeItem(storageKey(username));
    return;
  }

  Object.keys(sessionStorage)
    .filter((key) => key.startsWith(`${ADMIN_MFA_SESSION_KEY}:`))
    .forEach((key) => sessionStorage.removeItem(key));
}

export function isAdminMfaSessionSatisfied(username) {
  if (!username) {
    return false;
  }

  return sessionStorage.getItem(storageKey(username)) === '1';
}
